import React,{Component} from 'react';
import "./style.less";
import {NavBar,Toast,ListView,Icon,Modal} from "antd-mobile";
import {connect} from "react-redux";
import {getshuntList,shuntFakeConverse} from "../../../../service/homeService";
import {cancelRent,rentList} from "../../../../service/rentService";

let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../../common/image/wrongData.png');
const noOrder = require('../../../../common/image/noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class RentCar extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            showModal:false,
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
            orderId:'',
            orderTime:'',
            lineName:'',
            passagerNum:'',
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                searchType:0
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        rentList(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    callPhone =(e,id)=>{
        console.log(id)
        e.stopPropagation()
        this.setState({
            showModal:true,
            orderId:id
        })
    }
    number=(id)=>{ 
        // let params = {
        //     token: this.props.userInfo.token,
        //     "data": {
        //         "id": id,
        //         orderSource:6,
        //     }
        // };
        // shuntFakeConverse(params).then((res) => {
        //     console.log(res)
        //     if (res.data.code === '0000') {
                window.location.href = "tel://" + id;
            // }
            // else if (res.data.code === '1401') {
            //     document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            // }
            // else {
            //     Toast.info(res.data.msg);
            // }
        // }).catch(function (error) {
        //     console.log(error);
        // });
    }
    status = (params) =>{
        if(params === 0){
            return "待审核"
        }
        if(params === 1){
            return "待付款"
        }
        if(params === 2){
            return "待出行"
        }
        if(params === 3){
            return "行程中"
        }
        if(params === 4){
            return "已完成"
        }
        if(params === 99){
            return "已取消"
        }
        if(params === 98){
            return "已退款"
        }
    }
    backInvoice(item,type){
        Toast.loading('',0);
        let params = {
            token: this.props.userInfo.token,
            data: {id:item.id}
        };
        cancelRent(params).then((res) => {
            if (res.data.code === '0000') {
                pageIndex = 1;
                let param={
                    token: this.props.userInfo.token,
                    data:{
                        pageSize: pageSize,
                        pageNum: 1,
                        searchType:0
                    }
                };
                this.setState({
                    OrderListData:[]
                })
                if(type === "close"){
                    Toast.info("关闭成功，订单已取消！",2,()=>this._getOrderList(param));
                }
                else if(type === "refund"){
                    Toast.info("操作成功，请关注退款进度！",2,()=>this._getOrderList(param));
                }
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    btnFunction = (params,i) =>{
        if(params === 0){
            return <div className="btnContent"><div className="btn close" onClick={(e)=>{e.stopPropagation();
                Modal.alert('提示', '您确定要关闭吗?关闭订单前请务必与乘客协商！', [
                    { text: '取消'},
                    { text: '确定', onPress: () => this.backInvoice(i,'close')},
                ])}}>关闭订单</div><div className="btn">确认订单</div></div>
        }
        if(params === 1){
            return <div className="btnContent"><div className="btn close" onClick={(e)=>{e.stopPropagation();
                Modal.alert('提示', '您确定要关闭吗?关闭订单前请务必与乘客协商！', [
                    { text: '取消'},
                    { text: '确定', onPress: () => this.backInvoice(i,'close')},
                ])}}>关闭订单</div></div>
        }
        // if(params === 2){
        //     return <div className="btnContent"><div className="btn close"  onClick={(e)=>{e.stopPropagation();
        //         Modal.alert('提示', '您确定要退款吗？', [
        //             { text: '取消'},
        //             { text: '确定', onPress: () => this.backInvoice(i,'refund')},
        //         ])}}>退款</div></div>
        // }
        if(params === 3){
            return "行程中"
        }
        if(params === 4){
            return "已完成"
        }
        if(params === 99){
            return "已取消"
        }
        if(params === 98){
            return <div className="btnContent"><div className="btn close" onClick={(e)=>{e.stopPropagation();this.props.goPage('rentRefund',i)}}>退款进度</div></div>
        }
    }
    skipConfirm = (status,i) => {
       
        if(status == 0){
            this.props.goPage('rentConfirm',i,{type:'confirm'})
        }else{
            this.props.goPage('rentConfirm',i)
            
        }
        
    }
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="list" key={rowID} onClick={()=>this.skipConfirm(i.status,i)}>
                <div className="top">
                    <span>订单号  {i.orderNum}</span>
                    <span>{this.status(i.status)}</span>
                </div>
                <div className="middle">
                    <div className="location">
                        <div className="line">
                            <div>
                                <span className="stCity">{i.lineName}</span>
                                <div className="people"><span>{i.orderType === 0 ? "单程包车" : (i.orderType === 1 ? "往返包车" : "按天包车")}</span> <span>{i.passagerNum}人</span></div>
                                <div className="date">{i.estimatedTimeOfDeparture}</div>
                                {i.driverName ? <div className="name">{i.driverName}<span className="carNum">{i.carNum}</span></div> : null}
                            </div>
                            <div className="phone" onClick={(e)=>this.callPhone(e,i.phone)}><i className="icon iconfont icondianhuatubiao"></i></div>
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <span>价格：<span style={{color:"#F79E24"}}>{i.totalPrice ? ("￥"+ i.totalPrice) : "待确认"}</span></span>
                    {this.btnFunction(i.status,i)}
                </div>
            </div>
        )
        return(
            <div className="RentCar">
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                    <Modal
                        className="combineBillViewModal"
                        visible={this.state.showModal}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '否', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});this.number(this.state.orderId) } }]}
                    >
                        <div className="modalTitle">
                            <div>是否确认拨打电话？</div>
                             {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                        </div>
                    </Modal>     
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/rentCar/index.js